import {useEffect, useRef} from 'react';
import {observer} from 'mobx-react';
import bundleStore from '../../../store/bundleStore';
import BundleDone from './BundleDone';
import {pruneDirectReturns, readDirectReturn} from '../../../utils/pgDirect';

// 서버 /rooms/bundle/status 가 돌려주는 state: review·confirmed·released·paying·hold (nginx_single_page API src/services/bundle.js:105-110).
// 직접결제가 실패·닫힘으로 끝나면 주문은 state 'paying'(direct.phase failed|closed) 으로 남고(bundle.js:1046,1053,1096,1122,1260), status 는 이를
// approving 과 함께 'paying' 으로 접어 돌려준다 — 실패와 승인 중을 status 로는 못 가른다.
// 그래서 풀 수 있는 상태(paying·hold)에서만 cancel 을 부르고, 승인 중·확정·검토 중 보호는 서버 cancel 이 맡는다
// (bundle.js:75-79: review→review, approving·confirmed→released:false 로 풀지 않음).
// 서버가 이름을 바꾸면 BundleReturn.test.js 의 대역이 같이 깨지도록 상태값을 시험에도 그대로 쓴다.
const CANCELLABLE_STATES = ['paying', 'hold'];

export default observer(function BundleReturn() {
    const started = useRef(false);
    useEffect(() => {
        if (started.current) return;
        started.current = true;
        pruneDirectReturns();
        const saved = bundleStore.restorePayment();
        if (bundleStore.result) return;
        const params = new URLSearchParams(window.location.search);
        const hashParams = new URLSearchParams(window.location.hash.split('?')[1]);
        const value = key => params.get(key) ?? hashParams.get(key);
        const direct = readDirectReturn();
        // 직접결제는 서버가 확정까지 끝냈다 — URL 의 result 는 믿지 않고 항상 상태를 조회한다.
        // 이 탭이 시작한 결제이고 서버가 취소 가능 상태(failed·created)라고 답할 때만 기존 실패 경로(cancel→status)로 묶음을 푼다.
        if (direct) {
            const own = saved && direct.moid === bundleStore.payment?.bundle;
            if (!saved) bundleStore.savePayment({bundle: direct.moid});
            bundleStore.refreshStatus().then(state => {
                if (own && ['fail', 'cancel'].includes(direct.result) && CANCELLABLE_STATES.includes(state)) bundleStore.finishPayment({success: false});
            });
        } else if (value('merchant_uid') === bundleStore.payment?.bundle && (value('imp_uid') || value('imp_success') === 'false' || value('error_code'))) {
            bundleStore.finishPayment({success: value('imp_success') !== 'false' && !value('error_code'), imp_uid: value('imp_uid')});
        } else {
            bundleStore.refreshStatus();
        }
    }, []);
    const complete = !!bundleStore.result;
    const released = bundleStore.error === '결제가 취소되었습니다.';
    const failed = !released && !!bundleStore.error && !bundleStore.error.startsWith('결제 확인 중');
    const goHome = () => {
        localStorage.removeItem('userToken');
        bundleStore.reset();
        window.location.replace(window.location.pathname);
    };
    return <div className="confirm bundle-done">
        {complete ? <BundleDone onHome={goHome} /> : <>
            <header className="bundle-done-card bundle-done-header" role="status">
                <h1>{released ? '결제 취소됨' : failed ? '결제 확인 실패' : '결제 확인 중'}</h1>
                <p className="bundle-done-caption">{released ? '결제가 취소되었습니다.' : failed
                    ? '결제 결과를 확인하지 못했습니다. 재결제하지 말고 지점으로 문의해주세요.'
                    : '결제 결과를 확인하고 있습니다. 잠시 후 다시 확인해주세요.'}</p>
            </header>
            <div className="reserved_btn bundle-done-actions">
                {!released && <button type="button" disabled={bundleStore.checkingStatus} onClick={() => bundleStore.refreshStatus()}>다시 확인</button>}
                {(failed || released) && <button type="button" className="bundle-done-home" onClick={goHome}>홈으로</button>}
            </div>
        </>}
    </div>;
});
